import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { useState } from "react";
import { ProjectCard } from "./ProjectCard";
import "./Projects.css";

import { projectsFront, projectsBack, projectsTools } from '../data/proyectos';

import { FaLaptopCode } from "react-icons/fa";
import { FaDiagramProject } from "react-icons/fa6";

export const Projects = () => {
    const [activeTab, setActiveTab] = useState(
        sessionStorage.getItem('activeTab') || 'first'
    );

    const handleTabSelect = (key) => {
        setActiveTab(key);
        sessionStorage.setItem('activeTab', key);
    };

    return (
        <section className="project" id="projects">
            <Container>
                <div className="floating-element elem-1"><FaLaptopCode /></div>
                <div className="floating-element elem-2"><FaDiagramProject /></div>
                <Row>
                    <Col>
                        <h2>Proyectos</h2>
                        <Tab.Container id="projects-tabs" activeKey={activeTab} onSelect={handleTabSelect}>
                            <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Front-End</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Back-End</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third">Herramientas</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <Row className="justify-content-center">
                                        {
                                            projectsFront.map((project, index) => {
                                                return (
                                                    <ProjectCard key={index}
                                                        {...project} />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <Row className="justify-content-center">
                                        {
                                            projectsBack.map((project, index) => {
                                                return (
                                                    <ProjectCard key={index} {...project} />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                    <Row className="justify-content-center">
                                        {
                                            projectsTools.map((project, index) => {
                                                return (
                                                    <ProjectCard key={index} {...project} />
                                                )
                                            })
                                        }
                                    </Row>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}